import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';
import { store, persistor } from './store';
import './index.css';
import App from './App';
import 'font-awesome/css/font-awesome.min.css';
import '@splidejs/splide/dist/css/splide.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Crédito del desarrollador
// eslint-disable-next-line no-console
console.log(
  '%c ATST Radiocomunicaciones ',
  'background:#0f274b;color:#00BEE7;font-size:15px;font-weight:bold;padding:6px 14px;border-radius:6px;letter-spacing:1px;',
);
// eslint-disable-next-line no-console
console.log(
  '%cDiseñado y desarrollado por contacto@cristiandev.cl\n© 2025 CristianDev · https://cristiandev.cl',
  'color:#5f6f72;font-size:11px;',
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
);
